import { ApartmentEntry, ApartmentStatus } from '../../types/config';

export const inventoryDataHolon: ApartmentEntry[] = [
  {
    building: 'A',
    nrId: 1,
    number: 1,
    type: 'A',
    floor: 0,
    rooms: 4.5,
    area: 118,
    balconyArea: 81,
    status: ApartmentStatus.Available,
    id: 'A_01_select_floor0',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan1',
  },
  {
    building: 'A',
    nrId: 2,
    number: 2,
    type: 'B',
    floor: 0,
    rooms: 3,
    area: 66,
    balconyArea: 53,
    status: ApartmentStatus.Available,
    id: 'A_02_select_floor0',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan2',
  },
  {
    building: 'A',
    nrId: 3,
    number: 3,
    type: 'C',
    floor: 0,
    rooms: 5,
    area: 112,
    balconyArea: 110,
    status: ApartmentStatus.Available,
    id: 'A_03_select_floor0',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan3',
  },
  {
    building: 'A',
    nrId: 4,
    number: 4,
    type: 'D',
    floor: 1,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    id: 'A_04_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 5,
    number: 5,
    type: 'E',
    floor: 1,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_05_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 6,
    number: 6,
    type: 'E',
    floor: 1,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_06_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 7,
    number: 7,
    type: 'F',
    floor: 1,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    id: 'A_07_select_floor1',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 8,
    number: 8,
    type: 'G',
    floor: 1,
    rooms: 5,
    area: 112,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    id: 'A_08_select_floor1',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan8',
  },
  {
    building: 'A',
    nrId: 9,
    number: 9,
    type: 'H',
    floor: 1,
    rooms: 3.5,
    area: 82,
    balconyArea: 27,
    status: ApartmentStatus.Available,
    id: 'A_09_select_floor1',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan9',
  },
  {
    building: 'A',
    nrId: 10,
    number: 10,
    type: 'D',
    floor: 2,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_10_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 11,
    number: 11,
    type: 'E',
    floor: 2,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_11_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 12,
    number: 12,
    type: 'E',
    floor: 2,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_12_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 13,
    number: 13,
    type: 'F',
    floor: 2,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_13_select_floor2',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 14,
    number: 14,
    type: 'I',
    floor: 2,
    rooms: 5,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_14_select_floor2',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan14',
  },
  {
    building: 'A',
    nrId: 15,
    number: 15,
    type: 'J',
    floor: 2,
    rooms: 3.5,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    id: 'A_15_select_floor2',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan15',
  },
  {
    building: 'A',
    nrId: 16,
    number: 16,
    type: 'K',
    floor: 2,
    rooms: 3.5,
    area: 74,
    balconyArea: 14,
    status: ApartmentStatus.Sold,
    id: 'A_16_select_floor2',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'Floorplan16',
  },
  {
    building: 'A',
    nrId: 17,
    number: 17,
    type: 'D',
    floor: 3,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_17_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 18,
    number: 18,
    type: 'E',
    floor: 3,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_18_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 19,
    number: 19,
    type: 'E',
    floor: 3,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_19_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 20,
    number: 20,
    type: 'F',
    floor: 3,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_20_select_floor3',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 21,
    number: 21,
    type: 'I',
    floor: 3,
    rooms: 5,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_21_select_floor3',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan21',
  },
  {
    building: 'A',
    nrId: 22,
    number: 22,
    type: 'J',
    floor: 3,
    rooms: 3.5,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    id: 'A_22_select_floor3',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan22',
  },
  {
    building: 'A',
    nrId: 23,
    number: 23,
    type: 'L',
    floor: 3,
    rooms: 3.5,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Sold,
    id: 'A_23_select_floor3',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan23',
  },
  {
    building: 'A',
    nrId: 24,
    number: 24,
    type: 'D',
    floor: 4,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_24_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 25,
    number: 25,
    type: 'E',
    floor: 4,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_25_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 26,
    number: 26,
    type: 'E',
    floor: 4,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_26_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 27,
    number: 27,
    type: 'F',
    floor: 4,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_27_select_floor4',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 28,
    number: 28,
    type: 'I',
    floor: 4,
    rooms: 5,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_28_select_floor4',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan28',
  },
  {
    building: 'A',
    nrId: 29,
    number: 29,
    type: 'J',
    floor: 4,
    rooms: 3.5,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    id: 'A_29_select_floor4',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan29',
  },
  {
    building: 'A',
    nrId: 30,
    number: 30,
    type: 'L',
    floor: 4,
    rooms: 3.5,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Sold,
    id: 'A_30_select_floor4',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan30',
  },
  {
    building: 'A',
    nrId: 31,
    number: 31,
    type: 'M',
    floor: 5,
    rooms: 6,
    area: 141,
    balconyArea: 20,
    status: ApartmentStatus.Sold,
    id: 'A_31_select_floor5',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan31',
  },
  {
    building: 'A',
    nrId: 32,
    number: 32,
    type: 'E',
    floor: 5,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_32_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 33,
    number: 33,
    type: 'F',
    floor: 5,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_33_select_floor5',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 34,
    number: 34,
    type: 'I',
    floor: 5,
    rooms: 5,
    area: 105,
    balconyArea: 11,
    status: ApartmentStatus.Sold,
    id: 'A_34_select_floor5',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan34',
  },
  {
    building: 'A',
    nrId: 35,
    number: 35,
    type: 'J',
    floor: 5,
    rooms: 3.5,
    area: 75,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    id: 'A_35_select_floor5',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan35',
  },
  {
    building: 'A',
    nrId: 36,
    number: 36,
    type: 'L',
    floor: 5,
    rooms: 3.5,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Sold,
    id: 'A_36_select_floor5',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan36',
  },
  {
    building: 'A',
    nrId: 37,
    number: 37,
    type: 'D',
    floor: 6,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    id: 'A_37_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 38,
    number: 38,
    type: 'E',
    floor: 6,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_38_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 39,
    number: 39,
    type: 'E',
    floor: 6,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_39_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 40,
    number: 40,
    type: 'F',
    floor: 6,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    id: 'A_40_select_floor6',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 41,
    number: 41,
    type: 'I',
    floor: 6,
    rooms: 5,
    area: 110,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    id: 'A_41_select_floor6',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan41',
  },
  {
    building: 'A',
    nrId: 42,
    number: 42,
    type: 'N',
    floor: 6,
    rooms: 3,
    area: 68,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    id: 'A_42_select_floor6',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan42',
  },
  {
    building: 'A',
    nrId: 43,
    number: 43,
    type: 'L',
    floor: 6,
    rooms: 3.5,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    id: 'A_43_select_floor6',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan43',
  },
  {
    building: 'A',
    nrId: 44,
    number: 44,
    type: 'D',
    floor: 7,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    id: 'A_44_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 45,
    number: 45,
    type: 'E',
    floor: 7,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_45_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 46,
    number: 46,
    type: 'E',
    floor: 7,
    rooms: 3,
    area: 62,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_46_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/38-b58bea67',
    galleryType: 'gallerye',
    hasVideo: true,
    galleryCount: 15,
    floorPlanImage: 'floorplane',
  },
  {
    building: 'A',
    nrId: 47,
    number: 47,
    type: 'F',
    floor: 7,
    rooms: 4,
    area: 80,
    balconyArea: 11,
    status: ApartmentStatus.Available,
    id: 'A_47_select_floor7',
    tourUrl: 'https://my.treedis.com/tour/37-ff5fe4d9',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan37',
  },
  {
    building: 'A',
    nrId: 48,
    number: 48,
    type: 'I',
    floor: 7,
    rooms: 5,
    area: 110,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    id: 'A_48_select_floor7',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan48',
  },
  {
    building: 'A',
    nrId: 49,
    number: 49,
    type: 'N',
    floor: 7,
    rooms: 3,
    area: 68,
    balconyArea: 12,
    status: ApartmentStatus.Available,
    id: 'A_49_select_floor7',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan49',
  },
  {
    building: 'A',
    nrId: 50,
    number: 50,
    type: 'L',
    floor: 7,
    rooms: 3.5,
    area: 81,
    balconyArea: 13,
    status: ApartmentStatus.Available,
    id: 'A_50_select_floor7',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan50',
  },
  {
    building: 'A',
    nrId: 51,
    number: 51,
    type: 'O',
    floor: 8,
    rooms: 5,
    area: 112,
    balconyArea: 20,
    status: ApartmentStatus.Available,
    id: 'A_51_select_floor8',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan51',
  },
  {
    building: 'A',
    nrId: 52,
    number: 52,
    type: 'P',
    floor: 8,
    rooms: 3,
    area: 56,
    balconyArea: 9,
    status: ApartmentStatus.Available,
    id: 'A_52_select_floor8',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan52',
  },
  {
    building: 'A',
    nrId: 53,
    number: 53,
    type: 'Q',
    floor: 8,
    rooms: 5,
    area: 110,
    balconyArea: 70,
    status: ApartmentStatus.Available,
    id: 'A_53_select_floor8',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan53',
  },
  {
    building: 'A',
    nrId: 54,
    number: 54,
    type: 'R',
    floor: 8,
    rooms: 5,
    area: 114,
    balconyArea: 121,
    status: ApartmentStatus.Available,
    id: 'A_54_select_floor8',
    tourUrl: 'https://my.treedis.com/tour/54',
    kind: 'penthouse',
    galleryType: 'galleryr',
    hasVideo: true,
    galleryCount: 20,
    floorPlanImage: 'floorplan54',
  },
  {
    building: 'A',
    nrId: 55,
    number: 55,
    type: 'S',
    floor: 9,
    rooms: 5,
    area: 115,
    balconyArea: 114,
    status: ApartmentStatus.Available,
    id: 'A_55_select_floor9',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan55',
  },
  {
    building: 'A',
    nrId: 56,
    number: 56,
    type: 'T',
    floor: 9,
    rooms: 5,
    area: 112,
    balconyArea: 64,
    status: ApartmentStatus.Available,
    id: 'A_56_select_floor9',
    tourUrl: '',
    galleryType: 'gallery37',
    hasVideo: true,
    galleryCount: 31,
    floorPlanImage: 'floorplan56',
  },
];
